import { collection, doc } from 'firebase/firestore';
import React, { useContext, useState } from 'react'
import { MdCheck, MdClose } from "react-icons/md";
import { useParams } from 'react-router-dom';
import { FirebaseContext } from '../services/Firebase';

const NewLaneForm = ({onCancel, t, onAdd}: any) => {
  const [title, setTitle] = useState('')
  const { db } = useContext(FirebaseContext) || {}
  const { id, moduleId } = useParams();

  const handleAdd = () => {
    if(!db || !id || !moduleId) return
    if(!title) return
    onAdd({
      id: doc(collection(db, "training", id, 'modules', moduleId, 'sequences')).id,
      title
    })
  }

  return (
    <section className='p-1'>
      <input type="text" name="title" className="
          mt-1
          block
          w-full
          rounded
          border-none
          text-sm
          focus:border-purple-300 focus:ring focus:ring-purple-200 focus:ring-opacity-50
        " placeholder="Nom de la séquence"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <div className='flex'>
        <button
          onClick={handleAdd}
          className='flex items-center mt-1 ml-2 py-1 px-2 text-lime-500 font-bold text-sm'>
            <MdCheck className='mr-1' size={20}/>Créer
        </button>
        <button
          onClick={onCancel}
          className='flex items-center bg-transparent mt-1 ml-2 py-1 px-2 text-red-500 font-bold text-sm'>
            <MdClose className='mr-1' size={20}/> Annuler
        </button>
      </div>
    </section>
  )
}

export default NewLaneForm; 
